<template>
  <div id="app">
    <main-header></main-header>
    <div class="main-content">
      <main-menu @func="getSubNav" ref="menu"></main-menu>
      <div class="main-body">
        <!-- <el-breadcrumb separator="/" v-if="subNav&&subNav.length>0">
          <template v-for="(item,index) in subNav">
            <el-breadcrumb-item :key="index" v-if="item.path"><a :href="'/'+item.path">{{item.name}}</a></el-breadcrumb-item>
            <el-breadcrumb-item :key="index" v-else>{{item.name}}</el-breadcrumb-item>
          </template>
        </el-breadcrumb> -->
        <el-tabs v-model="editableTabsValue" type="card" :closable="editableTabs.length>1?true:false" @tab-remove="removeTab" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in editableTabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          >
            {{item.content}}
          </el-tab-pane>
        </el-tabs>
        <div  class="main-body-child">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "./components/header/index.vue";
import MainMenu from "./components/menu/index.vue";

export default {
  name: "app",
  data(){
    return{
      subNav:[],
      editableTabs:[],
      editableTabsValue:''
    }
  },
  components: {
    MainHeader,
    MainMenu
  },
  watch:{
    editableTabsValue(val){
      setTimeout(()=>{
        this.$router.push({name:val})
        this.$refs.menu.routeActiveFunc(this.$route);
      },100)
    }
  },
  async mounted() {
    this.editableTabsValue=this.$route.name
    let editableTabs = sessionStorage.getItem('editableTabs')
    if(editableTabs){
      this.editableTabs=JSON.parse(editableTabs)
    }
  },
  methods:{
    getSubNav(data){
      if(data.length>0) {
        let subNav = data[data.length-1]
        let index = this.editableTabs.findIndex(x=>x.name==subNav.path)
        if(index==-1) {
          this.editableTabs.push({
            title: subNav.name,
            name: subNav.path,
            content:''
          })
          this.editableTabsValue = subNav.path;
          sessionStorage.setItem('editableTabs',JSON.stringify(this.editableTabs))
        }else{
          this.editableTabsValue = subNav.path;
        }
      }
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      sessionStorage.setItem('editableTabs',JSON.stringify(this.editableTabs))
    },
    handleClick(tab, event) {

    }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  background-size: cover;
  font-family: "Microsoft YaHei", "PingFang SC", -apple-system, "Helvetica Neue",
    Helvetica, Arial, "Microsoft Jhenghei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .main-content {
    width: inherit;
    height: calc(100% - 56px);
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .main-body {
    width: 100%;
		height: 100%;
    margin:15px;
    margin-right: 10px;
    margin-top: 0;
    overflow-y: auto;
    overflow-x: auto;
  }
  .main-body-child{
    padding: 15px;
    padding-top: 5px;
    padding-bottom: 0px;
    background: #fff;
    border-radius: 5px;
  }
}
</style>
